import { Object3D, Vector3, Texture, MathUtils } from "three";
import { Sky } from "three/examples/jsm/objects/Sky.js";

class OuterScene extends Object3D {
  public sky: Sky;
  public sunPosition: Vector3;
  public environment: Texture;

  constructor() {
    super();

    this.sky = new Sky();
    this.sky.scale.setScalar(1000);
    this.add(this.sky);

    const parameters = {
      elevation: 5,
      azimuth: 180,
    };

    const phi = MathUtils.degToRad(90 - parameters.elevation);
    const theta = MathUtils.degToRad(parameters.azimuth);

    this.sunPosition = new Vector3();
    this.sunPosition.setFromSphericalCoords(1, phi, theta);

    this.sky.material.uniforms["turbidity"].value = 18;
    this.sky.material.uniforms["rayleigh"].value = 4;
    this.sky.material.uniforms["mieCoefficient"].value = 0.1;
    this.sky.material.uniforms["mieDirectionalG"].value = 0.82;
    this.sky.material.uniforms["sunPosition"].value.copy(this.sunPosition);
  }
}

export default OuterScene;
